import React, { Component } from 'react';
import {
  Link
}from 'react-router-dom';


import {Carousel, Modal, Button, Grid, Row, Col, Thumbnail} from 'react-bootstrap';
import ReactDOM from 'react-dom';


// Images


import imageWF from './images/wf_symbol.png';
import imageSB from './images/sb_symbol.png';
import imageAuto from './images/automat_symbol.png';
import imageService from './images/zubehoer_symbol.png';
import welcomePicture from './images/welcomePicture2.jpeg';

import imageCustomerPrimary01 from './images/Logos_Lieferanten/demmeler.png';
import imageCustomerPrimary02 from './images/Logos_Lieferanten/exeron.png';
import imageCustomerPrimary03 from './images/Logos_Lieferanten/fehlmann.png';
import imageCustomerPrimary04 from './images/Logos_Lieferanten/pcam.png';

import imageCustomerPrimary05 from './images/Logos_Lieferanten/fetzer.png';
import imageCustomerPrimary06 from './images/Logos_Lieferanten/davi.png';
import imageCustomerPrimary07 from './images/Logos_Lieferanten/loewer.png';
import imageCustomerPrimary08   from './images/Logos_Lieferanten/ziersch.png';

import imageCustomerPrimary09 from './images/Logos_Lieferanten/msmarking.png';
import imageCustomerPrimary10 from './images/Logos_Lieferanten/aeroLift.png';
import imageCustomerPrimary11 from './images/Logos_Lieferanten/Gressel.png';
import imageCustomerPrimary12 from './images/Logos_Lieferanten/sllaser.png';

import imageCustomerPrimary13 from './images/Logos_Lieferanten/nordLock.png';
import imageCustomerPrimary14 from './images/Logos_Lieferanten/carif.png';
import imageCustomerPrimary15 from './images/Logos_Lieferanten/steidle.png';
import imageCustomerPrimary16 from './images/Logos_Lieferanten/almi.png';

import imageCustomerPrimary17 from './images/Logos_Lieferanten/aalbersfarina.png';
import imageCustomerPrimary18 from './images/Logos_Lieferanten/jara.png';
import imageCustomerPrimary19 from './images/Logos_Lieferanten/ebs.png';
import imageCustomerPrimary20 from './images/Logos_Lieferanten/bodor.png';
import imageCustomerPrimary21 from './images/Logos_Lieferanten/fanuc.png';


import imageHighlight from './images/highlight/banner_hausaustellung.png';
import imageHighlightMB from './images/highlight/banner_hausaustellung.png';


import imageCustomerPrimaryDefault from './images/Logos_Lieferanten/default.gif';


import vdwf from './images/vdwf.png';

// bootstrap layout


class Homepage extends Component {


  constructor(props, context) {
    super(props, context);


    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.state = {
      show: false,
      product: 'Default',
      listItemsProperties: '',
      sizeType: '',
      sizeData: '',
      sizeMeas: '',
      pdfLink: '',
      pdfAlias: '',
      image: ''
    };




  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }



  handleUpdate(product) {
    var productTmp = JSON.parse(product);
    var productArr = productTmp[0].prop;
    this.setState({listItemsProperties: productArr.map((elementEx) =>
    <li key={elementEx.data}>{elementEx.data}</li>
    )});
    return (
      <ul>{this.state.listItemsProperties}</ul>
    );
  }




  

  render() {
    window.scrollTo(0, 0);
    var dataNews;
    var dataVideo;
    var builtTmpNews;
    var builtTmpVideos;
    var parseStringNews = require('xml2js').parseString;
    fetch('/newsData.xml')
    .then((r) => r.text())
    .then(text  => {
      parseStringNews(text, function (err, result) {
          dataNews=result;
          var tmpOV = JSON.parse(JSON.stringify(result));
          dataNews= tmpOV.NewsList.News;
          dataNews = dataNews.slice(0, 3);
          builtTmpNews = dataNews.map((element) =>
                <Col xs={12} sm={6} md={4} lg={4} className="newsItem">
                  <div className="newsCont">
                    <img src={`../news/${element.Image}`} alt={element.Title} id={`image ${element.Title}`} className={`newsImg${element.classType}`} />
                    <video id="background-video" className={`newsVideo${element.classType}`} loop autoPlay id={`video ${element.Title}`} playsInLine="true">
                        <source src={`../videos/${element.FileShort}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    <h4>{element.Title}</h4>
                    <h5>{element.Supplier}</h5>
                  </div>
                </Col>

              );
          }.bind(this));
          this.builtElement = ReactDOM.render(builtTmpNews, document.getElementById('newsRoot'));
      });

      var data;
      var builtTmp;
      var parseString = require('xml2js').parseString;

        fetch('/newProds.xml')
        .then((r) => r.text())
        .then(text  => {
          parseString(text, function (err, result) {
              data=result;
              var tmpOV = JSON.parse(JSON.stringify(result));
              data= tmpOV.maschinen.maschine;
              data = data.slice(0, 4);
              builtTmp = data.map((element) =>
              <Col xs={12} md={3} >
                <Thumbnail className="thumbNail" src={element.Image} alt={element.Name}>
                  <div className="prodHomePage">
                    <h4>{element.Name}</h4>
                    <h5>{element.Supplier}</h5>
                    <br/>
                      <Button bsStyle="primary" onClick={() => {
                        this.setState({product: element.Name, sizeData: element.sizeData, sizeMeas: element.sizeMeas, sizeType: element.sizeType, pdfLink: element.pdfLink, pdfAlias: element.pdfAlias, image: element.Image});
                        this.handleUpdate(JSON.stringify(element.properties));
                        this.handleShow();
                      }}>Mehr Informationen</Button>
                    </div>
                </Thumbnail>
              </Col>

              );

            }.bind(this));
            this.builtElement = ReactDOM.render(builtTmp, document.getElementById('newProdsRoot'));
        });



    return (
      <div className="mainCont">
        <section>
          <div className="homePageJumbo">
            <center>
              <Grid>
                <Row>
                  <Col  xs={12} smHidden mdHidden lgHidden>
                    <div className="backgroundForTextSmall">
                      <h3>Herzlich Willkommen bei Mauersberger Industrievertretungen!</h3>
                      <p className="standardTextSmall">
                        Die Firma Mauersberger ist seit 1962 eine klassische Industrievertretung,
                        mit dem Schwerpunkt Metallverarbeitung und Werkzeug-/Formenbau. Aufgrund des ständig währenden Fortschritts wurde das Sortiment zusätzlich auf den Bereich Roboter-Automatisierung erweitert.
                      </p>
                      <center>

                        <Link to="/WhoWeAre">
                        <Button className="buttonMainDesign" bsStyle="primary" >Wer wir sind &raquo;</Button>
                      </Link>
                      </center>
                    </div>
                    <img src={welcomePicture} alt="Mauersberger Background Image IOT 4.0" fetchpriority="high"/>
                  </Col>
                  <Col xsHidden  md={12}>
                    {/* <h2 className="mainH2">Herzlich Willkommen bei Mauersberger Industrievertretungen!</h2> */}
                    <div className="backgroundForText">
                      <h3>Herzlich Willkommen bei Mauersberger Industrievertretungen!</h3>
                      <p className="standardText">
                        Die Firma Mauersberger ist seit 1962 eine klassische Industrievertretung,
                        mit dem Schwerpunkt Metallverarbeitung und Werkzeug-/Formenbau. Aufgrund des ständig währenden Fortschritts wurde das Sortiment zusätzlich auf den Bereich Roboter-Automatisierung erweitert.
                      </p>
                      <center>

                        <Link to="/WhoWeAre">
                        <Button className="buttonMainDesign" bsStyle="primary" >Wer wir sind &raquo;</Button>
                      </Link>
                      </center>
                    </div>
                    <img src={welcomePicture} alt=""/>
                  </Col>
                </Row>
              </Grid>

              </center>
              
          </div>
        </section>
        {/* <Link to="/Highlight">
          <Grid>
            <Row>
              <Col xs={12}  mdHidden lgHidden>
                <img className="homePageImage special-shadow" src={imageHighlight} alt="Mauersberger Hausausstellung 2026"/>
              </Col>
              <Col xsHidden smHidden md={12}>
                <img className="homePageImage special-shadow" src={imageHighlightMB} alt="Mauersberger Hausausstellung 2026"/>
              </Col>
            </Row>
          </Grid>
        </Link>
        <hr/> */}
        <section>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 text-center">
                <h2>Qualität im Vertrieb und den Produkten</h2>
                <p className="standardText">Für viele endet der Service mit dem Verkauf des Produkts. Dies entspricht nicht unserer Philosophie. Denn wir wollen, dass Sie mit unseren Produkten zufrieden sind und das Maximum aus ihnen herausholen können!</p>
                
              </div>
            </div>
          </div>
        </section>
        <section>
          <Grid>
            <Row className="show-grid">
              <Col xs={6}  sm={3} >
                <Link to="/Suppliers/WuF">
                  <img  src={imageWF} alt="..." width="70%" />
                <h4 >Werkzeug- und Formenbau</h4>
                <p className="presentTextDesc"> Präzesionsfräsen, HSC-Fräsen, Senkerodieren, Flachschleifen, Messen und Spannmittel</p>
                </Link>
              </Col>
              <Col xs={6}  sm={3}  >
                <Link to="/Suppliers/SuB">
                  <img  src={imageSB} alt="..." width="70%"/>
                <h4 >Stahlbau und Blechbearbeitung</h4>
                  <p className="presentTextDesc">3D-Spannsysteme, Endgratung, Biegen und Schneiden</p>
                </Link>
              </Col>
              <Col xsHidden  sm={3}>
                <Link to="/Suppliers/Automatisierung">
                  <img  src={imageAuto} alt="..." width="70%"/>
                <h4 >Automatisierung</h4>
                    <p className="presentTextDesc">Vollautomatische Roboterautomation zur Verknüpfung von Fertigungstechnologien</p>
                  </Link>
              </Col>
              <Col xsHidden  sm={3}>
                <Link to="/Suppliers/Zubehoer">
                  <img  src={imageService} alt="..." width="70%"/>
                <h4 >Zubehör</h4>
                    <p className="presentTextDesc">Heben, Fasen, Sprühen, Laserprojektion und Markieren</p>
                  </Link>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">

              <Col xs={6}  smHidden mdHidden lgHidden>
                <Link to="/Suppliers/Automatisierung">
                  <img  src={imageAuto} alt="..." width="70%"/>
                <h4 >Automatisierung</h4>
                    Vollautomatische Roboterautomation zur Verknüpfung von Fertigungstechnologien
                  </Link>
              </Col>
              <Col xs={6}  smHidden mdHidden lgHidden>
                <Link to="/Suppliers/Zubehoer">
                  <img  src={imageService} alt="..." width="70%"/>
                <h4 >Zubehör</h4>
                    Heben, Fasen, Sprühen, Laserprojektion und Markieren
                  </Link>
              </Col>

            </Row>
          </Grid>


        </section>
        <hr/>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h1>Neue Produkte!</h1>
                <p className="standardText">Hier sehen sie auf den ersten Blick unsere neuen Produkte.</p>
                <Grid class="news">
                  <Row id="newProdsRoot" className='container-fluid  at-homePage'/>
                </Grid>
              </div>
            </div>
          </div>
        </section>
        <br/>
        <hr/>
      <br/>
        <section>

          <div className="container">
        		<div className="row">
                	<div className="col-lg-12 text-center">
                	  <h2>Unsere Lieferanten</h2>
                	  <p className="standardText" >Durch unser breites Sortiment können wir Ihnen eine Vielzahl an Produkten anbieten:</p>
                    </div>
                </div>
              </div>
          <Grid>
            <Row className="show-grid">
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Demmeler" name="Demmeler Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary01} alt="Demmeler Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Exeron" name="Exeron Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary02} alt="Exeron Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Fehlmann" name="Fehlmann Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary03} alt="Fehlmann Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Pcam" name="Pcam Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary04} alt="PCam Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Ziersch" name="Ziersch Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary08} alt="Ziersch Logo" width="100%" height="auto"  /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Loewer" name="Loewer Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary07} alt="Loewer Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Bodor" name="Bodor Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary20} alt="Bodor Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Fetzer" name="Fetzer Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary05} alt="Fetzer Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Davi" name="Davi Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary06} alt="Davi Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/MSMarking" name="MSMarking Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary09} alt="MSMarking Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Aerolift" name="Aerolift Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary10} alt="Aerolift Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Gressel" name="Gressel Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary11} alt="Gressel Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Carif" name="Carif Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary14} alt="Carif Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Nordlock" name="Nordlock Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary13} alt="Nordlock Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/SLLaser" name="SLLaser Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary12} alt="SLLaser Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Steidle" name="Steidle Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary15} alt="Steidle Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Almi" name="Almi Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary16} alt="Almi Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/aalbersfarina" name="aalbers farina Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary17} alt="aalbers farina Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Jara" name="Jara Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary18} alt="Jara Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Ebs" name="EB.S. Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary19} alt="EB.S. Logo" width="100%" height="auto" /></Link>
              </Col>
              <Col xsHidden  sm={2}>
                <Link to="/Suppliers/Fanuc" name="Fanuc Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary21} alt="Fanuc Logo" width="100%" height="auto" /></Link>
              </Col>
            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>
                <Carousel  controls={false} interval={3000}>
                  <Carousel.Item>
                    <Grid>
                      <Row className="show-grid">
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Demmeler" name="Demmeler Overview Page" ><img className="imageOverviewLieferant" src={imageCustomerPrimary01} alt="Demmeler Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Exeron" name="Exeron Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary02} alt="Exeron Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Fehlmann" name="Fehlmann Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary03} alt="Fehlmann Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Pcam" name="Pcam Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary04} alt="PCam Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Bodor" name="Bodor Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary20} alt="Bodor Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Ziersch" name="Ziersch Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary08} alt="Ziersch Logo" width="100%" height="auto" /></Link>
                        </Col>
                      </Row>
                    </Grid>
                  </Carousel.Item>
                  <Carousel.Item>
                    <Grid>
                      <Row className="show-grid">
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Aerolift" name="Aerolift Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary10} alt="AeroLift Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Loewer" name="Loewer Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary07} alt="Loewer Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/MSMarking" name="MSMarking Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary09} alt="MSMarking Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Davi" name="Davi Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary06} alt="Davi Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Gressel" name="Gressel Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary11} alt="Gressel Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/SLLaser" name="SLLaser Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary12} alt="SLLaser Logo" width="100%" height="auto" /></Link>
                        </Col>
                      </Row>
                    </Grid>
                  </Carousel.Item>
                  <Carousel.Item>
                    <Grid>
                      <Row className="show-grid">
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Nordlock" name="Nordlock Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary13} alt="Nordlock Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Carif" name="Carif Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary14} alt="Carif Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Steidle" name="Steidle Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary15} alt="Steidle Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Almi" name="Almi Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary16} alt="Almi Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/aalbersfarina" name="aalbers farina Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary17} alt="aalbers farina Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Jara" name="Jara Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary18} alt="Jara Logo" width="100%" height="auto" /></Link>
                        </Col>
                      </Row>
                    </Grid>
                  </Carousel.Item>
                  <Carousel.Item>
                    <Grid>
                      <Row className="show-grid">
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Ebs" name="EB.S. Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary19} alt="EB.S. Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <Link to="/Suppliers/Fanuc" name="Fanuc Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary21} alt="Fanuc Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col smHidden mdHidden lgHidden  xs={6}>
                          <Link to="/Suppliers/Fetzer" name="Fetzer Overview Page"><img className="imageOverviewLieferant" src={imageCustomerPrimary05} alt="Fetzer Logo" width="100%" height="auto" /></Link>
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <img className="imageOverviewLieferant" src={imageCustomerPrimaryDefault} alt="Default Logo" width="100%" height="auto" />
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <img className="imageOverviewLieferant" src={imageCustomerPrimaryDefault} alt="Default Logo" width="100%" height="auto" />
                        </Col>
                        <Col  smHidden mdHidden lgHidden xs={6}>
                          <img className="imageOverviewLieferant" src={imageCustomerPrimaryDefault} alt="Default Logo" width="100%" height="auto" />
                        </Col>
                      </Row>
                    </Grid>
                  </Carousel.Item>
                </Carousel>
              </Col>
            </Row>
          </Grid>
        </section>
        <hr/>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h1>Neuigkeiten !</h1>
                <p className="standardText">Hier sehen sie auf den ersten Blick unsere Neuigkeiten. Noch mehr Neuigkeiten finden sie <Link to="/News" name="News">hier</Link>.</p>
                <Grid class="newsGrid">
                  <Link to="/News" name="News">
                    <Row id="newsRoot" className='container-fluid  at-homePage'/>
                  </Link>
                </Grid>
              </div>
            </div>
          </div>
        </section>
        <hr/>
        <div className="section well">
            <div className="container">
           	  <div className="row">
        		      <div className="col-lg-12 col-md-12">
        		          <h3 className="text-center">So können Sie uns erreichen ... </h3>
                      <address className="text-center">
                        <strong>Mauersberger Industrievertretungen e.K.</strong><br/>
                          Siedlerstrasse 8<br/>
                            90574 Rosstal<br/><br/>
                        <abbr title="Phone">Telefon:</abbr> (+49) 9127 903866<br/>
          	            <abbr title="Fax">Fax:</abbr> (+49) 9127 903867	<br/><br/>
          	            <abbr title="Mail">Mail:</abbr> info@mauersberger-vertrieb.de<br/>
                      </address>
                  </div>

                </div>
            </div>
        	</div>
          <hr/>
          <section>
              <div className="container">
                <h3 className="text-center">Unsere Produktmatrix</h3>
                <div className="keyword-map">
                  <Link to="/Suppliers/Demmeler" name="Demmeler Overview Page"><h3>Demmeler</h3></Link>
                  <Link to="/Suppliers/Demmeler/Schweißtische" name="Demmeler Schweißtische"><h4>Schweißtische</h4></Link>
                  <Link to="/Suppliers/Demmeler/Innovationen?product=manipulatoren" name="Demmeler Manipualtoren"><h5>Manipulatoren</h5></Link>
                  <Link to="/Suppliers/Demmeler/Innovationen?product=cobot" name="Demmeler Cobot"><h4>COBOT Weldspace 4.0</h4></Link>
    		          <Link to="/Suppliers/Exeron" name="Exeron Overview Page"><h3>Exeron</h3></Link>
    		          <Link to="/Suppliers/Exeron/hsc" name="Exeron HSC"><h4>HSC</h4></Link>
    		          <Link to="/Suppliers/Exeron/hsc?product=hsc300" name="Exeron HSC 300"><h5>HSC 300</h5></Link>
    		          <Link to="/Suppliers/Exeron/hsc?product=hsc6005" name="Exeron HSC 600/5"><h5>HSC 600/5</h5></Link>
    		          <Link to="/Suppliers/Exeron/hsc?product=mp7" name="Exeron MP7"><h5>MP7</h5></Link>
    		          <Link to="/Suppliers/Exeron/hsc?product=mp9" name="Exeron MP9"><h5>MP9</h5></Link>
    		          <Link to="/Suppliers/Exeron/hsc?product=mp11" name="Exeron MP11"><h5>MP11</h5></Link>
    		          <Link to="/Suppliers/Exeron/edm" name="Exeron EDM"><h4>EDM</h4></Link>
    		          <Link to="/Suppliers/Exeron/edm?product=edm310" name="Exeron EDM 310"><h5>EDM 310</h5></Link>
    		          <Link to="/Suppliers/Exeron/edm?product=edm312" name="Exeron EDM 312"><h5>EDM 312</h5></Link>
    		          <Link to="/Suppliers/Exeron/edm?product=edm313" name="Exeron EDM 313"><h5>EDM 313</h5></Link>
    		          <Link to="/Suppliers/Exeron/edm?product=edm314" name="Exeron EDM 314"><h5>EDM 314</h5></Link>
    		          <Link to="/Suppliers/Exeron/edm?product=edm316" name="Exeron EDM 316"><h5>EDM 316</h5></Link>
    		          <Link to="/Suppliers/Fehlmann" name="Fehlmann Overview Page"><h3>Fehlmann</h3></Link>
    		          <Link to="/Suppliers/Fehlmann/Versa" name="Fehlmann Versa"><h4>Versa</h4></Link>
    		          <Link to="/Suppliers/Fehlmann/Versa?product=versa645" name="Fehlmann Versa 645"><h5>Versa 645</h5></Link>
    		          <Link to="/Suppliers/Fehlmann/Versa?product=versa825" name="Fehlmann Versa 825"><h5>Versa 825</h5></Link>
    		          <Link to="/Suppliers/Fehlmann/Picomax" name="Fehlmann Picomax"><h4>Picomax</h4></Link>
    		          <Link to="/Suppliers/Fehlmann/Picomax?product=picomax21" name="Fehlmann Picomax 21"><h5>Picomax 21</h5></Link>
    		          <Link to="/Suppliers/Fehlmann/Picomax?product=picomax56" name="Fehlmann Picomax 56"><h5>Picomax 56</h5></Link>
    		          <Link to="/Suppliers/Fehlmann/Picomax?product=picomax75" name="Fehlmann Picomax 75"><h5>Picomax 75</h5></Link>
    		          <Link to="/Suppliers/Fehlmann/Picomax?product=picomax95" name="Fehlmann Picomax 95"><h5>Picomax 95</h5></Link>
    		          <Link to="/Suppliers/PCam" name="PCam Overview Page"><h3>PCam</h3></Link>
    		          <Link to="/Suppliers/Davi" name="Davi Overview Page"><h3>Davi</h3></Link>
    		          <Link to="/Suppliers/Davi/Rundbiegen" name="Davi Rundbiegen"><h4>Rundbiegen</h4></Link>
    		          <Link to="/Suppliers/Davi/Rundbiegen?product=mav" name="Davi Rundbiegen MAV"><h5>MAV</h5></Link>
    		          <Link to="/Suppliers/Davi/Rundbiegen?product=mco" name="Davi Rundbiegen MCO"><h5>MCO</h5></Link>
    		          <Link to="/Suppliers/Davi/Rundbiegen?product=mca" name="Davi Rundbiegen MCA"><h5>MCA</h5></Link>
    		          <Link to="/Suppliers/Davi/Rundbiegen?product=mcb" name="Davi Rundbiegen MCB"><h5>MCB</h5></Link>
    		          <Link to="/Suppliers/Davi/Profilbiegen" name="Davi Profilbiegen"><h4>Profilbiegen</h4></Link>
    		          <Link to="/Suppliers/Ziersch" name="Ziersch Overview Page"><h3>Ziersch</h3></Link>
    		          <Link to="/Suppliers/Ziersch/Maschinen" name="Ziersch Schleifmaschinen"><h4>Schleifmaschinen</h4></Link>
    		          <Link to="/Suppliers/Ziersch/Maschinen?product=flach" name="Ziersch Flachschleifmaschinen"><h5>Flachschleifmaschinen</h5></Link>
    		          <Link to="/Suppliers/Ziersch/Maschinen?product=portal" name="Ziersch Portalschleifmaschinen"><h5>Portalschleifmaschinen</h5></Link>
    		          <Link to="/Suppliers/Ziersch/Maschinen?product=rund" name="Ziersch Rundschleifmaschinen"><h5>Rundschleifmaschinen</h5></Link>
    		          <Link to="/Suppliers/Ziersch/Maschinen?product=rundtisch" name="Ziersch Rundtischschleifmaschinen"><h5>Rundtischschleifmaschinen</h5></Link>
    		          <Link to="/Suppliers/Almi" name="Almi Overview Page"><h3>Almi</h3></Link>
    		          <Link to="/Suppliers/Almi/PipeGrinders" name="Almi Rohrausschleifer"><h4>Rohrausschleifer</h4></Link>
    		          <Link to="/Suppliers/Almi/PipeGrinders?product=al150" name="Almi AL150"><h5>AL150</h5></Link>
    		          <Link to="/Suppliers/Almi/PipeGrinders?product=al100u1" name="Almi AL100U"><h5>AL100U</h5></Link>
    		          <Link to="/Suppliers/Almi/PipeGrinders?product=al12u" name="Almi AL1-2U"><h5>AL1-2U</h5></Link>
    		          <Link to="/Suppliers/Almi/PipeGrinders?product=al1" name="Almi AL1"><h5>AL1</h5></Link>
    		          <Link to="/Suppliers/Loewer" name="Loewer Overview Page"><h3>Loewer</h3></Link>
    		          <Link to="/Suppliers/Loewer/Produkte" name="Loewer Band- und Bürstenschleifmaschinen"><h4>Band- und Bürstenschleifmaschinen</h4></Link>
    		          <Link to="/Suppliers/Loewer/Produkte?product=6td" name="Loewer DiscMaster"><h5>DiscMaster</h5></Link>
    		          <Link to="/Suppliers/Loewer/Produkte?product=k4td" name="Loewer BeltMaster"><h5>BeltMaster</h5></Link>
    		          <Link to="/Suppliers/Loewer/Produkte?product=swing" name="Loewer SwingGrinder"><h5>SwingGrinder</h5></Link>
    		          <Link to="/Suppliers/Loewer/Produkte?product=smart" name="Loewer SmartGrinder"><h5>SmartGrinder</h5></Link>
    		          <Link to="/Suppliers/Loewer/Produkte?product=cross" name="Loewer CrossMaster"><h5>CrossMaster</h5></Link>
    		          <Link to="/Suppliers/Steidle" name="Steidle Overview Page"><h3>Steidle</h3></Link>
    		          <Link to="/Suppliers/Steidle/mmks" name="Steidle MMKS"><h4>MMKS</h4></Link>
    		          <Link to="/Suppliers/Steidle/mmks?product=l60" name="Steidle Lubrimat"><h5>Lubrimat</h5></Link>
    		          <Link to="/Suppliers/Steidle/mmks?product=sf" name="Steidle Sägefix"><h5>Sägefix</h5></Link>
    		          <Link to="/Suppliers/Steidle/mmks?product=c30" name="Steidle Centermat"><h5>Centermat</h5></Link>
    		          <Link to="/Suppliers/Steidle/mmks?product=t70" name="Steidle Toolmat"><h5>Toolmat</h5></Link>
    		          <Link to="/Suppliers/Steidle/mmks?product=s700" name="Steidle Spraymat"><h5>Spraymat</h5></Link>
    		          <Link to="/Suppliers/Steidle/mmks?product=p35" name="Steidle Pulsomat"><h5>Pulsomat</h5></Link>
    		          <Link to="/Suppliers/Steidle/pic?product=pic" name="Steidle PIC"><h4>PIC - PROCESS INTEGRATED COATING</h4></Link>
    		          <Link to="/Suppliers/Fetzer" name="Fetzer Overview Page"><h3>Fetzer</h3></Link>
    		          <Link to="/Suppliers/Fetzer/Lager" name="Fetzer Lager- und Regalsysteme"><h4>Lager- und Regalsysteme</h4></Link>
    		          <Link to="/Suppliers/Fetzer/Lager?product=p3" name="Fetzer Palettenregale"><h5>Palettenregale</h5></Link>
    		          <Link to="/Suppliers/Fetzer/Lager?product=u90" name="Fetzer Weitspannregale"><h5>Weitspannregale</h5></Link>
    		          <Link to="/Suppliers/Fetzer/Lager?product=u30" name="Fetzer Steckregale"><h5>Steckregale</h5></Link>
    		          <Link to="/Suppliers/Fetzer/Lager?product=studio" name="Fetzer Aktenregale"><h5>Aktenregale</h5></Link>
    		          <Link to="/Suppliers/Fetzer/Lager?product=behaelter" name="Fetzer Behälterregale"><h5>Behälterregale</h5></Link>
    		          <Link to="/Suppliers/Fetzer/Lager?product=tischregal" name="Fetzer Tischregale"><h5>Tischregale</h5></Link>
    		          <Link to="/Suppliers/Fetzer/Sonstiges?product=staysafe" name="Fetzer StaySafe"><h4>StaySafe</h4></Link>
    		          <Link to="/Suppliers/Carif" name="Carif Overview Page"><h3>Carif</h3></Link>
    		          <Link to="/Suppliers/Carif/Produkte" name="Carif Bändsägemaschinen"><h4>Bandsägemaschinen</h4></Link>
    		          <Link to="/Suppliers/Carif/Produkte?product=450bsa" name="Carif Bändsägemaschinen Halbautomatisch (BSA)"><h5>BSA Halbautomatisch</h5></Link>
    		          <Link to="/Suppliers/Carif/Produkte?product=450ba" name="Carif Bändsägemaschinen CNC Vollautomatisch (BA)"><h5>BA CNC Vollautomatisch</h5></Link>
    		          <Link to="/Suppliers/Gressel" name="Gressel Overview Page"><h3>Gressel</h3></Link>
    		          <Link to="/Suppliers/SLLaser" name="SLLaser Overview Page"><h3>SLLaser</h3></Link>
    		          <Link to="/Suppliers/MSMarking" name="MSMarking Overview Page"><h3>MSMarking</h3></Link>
    		          <Link to="/Suppliers/Aerolift" name="AeroLift Overview Page"><h3>AERO-LIFT</h3></Link>
    		          <Link to="/Suppliers/Aerolift/vakuumheber" name="AeroLift Vakuumheber"><h4>Vakuumheber</h4></Link>
    		          <Link to="/Suppliers/Aerolift/baustellengeraete" name="AeroLift Baustellengeraete"><h4>Baustellengeräte</h4></Link>
    		          <Link to="/Suppliers/Aerolift/schlauchheber" name="AeroLift Schlauchheber"><h4>Schlauchheber</h4></Link>
    		          <Link to="/Suppliers/Aerolift/automation" name="AeroLift Automation"><h4>Automation</h4></Link>
    		          <Link to="/Suppliers/aalbersfarina" name="aalbers farina Overview Page"><h3>aalbers farina</h3></Link>
    		          <Link to="/Suppliers/aalbersfarina/Blechregale" name="aalbers farina Blechregale"><h4>Blechregale</h4></Link>
    		          <Link to="/Suppliers/aalbersfarina/Langgutregale" name="aalbers farina Langgutregale"><h4>Langgutregale</h4></Link>
    		          <Link to="/Suppliers/Jara" name="Jara Overview Page"><h3>Jara</h3></Link>
                  <Link to="/Suppliers/Ebs" name="EB.S. Overview Page"><h3>EB.S.</h3></Link>
                  <Link to="/Suppliers/Bodor" name="Bodor Overview Page"><h3>Bodor</h3></Link>
                  <Link to="/Suppliers/Bodor/Laserschneiden" name="Bodor Laserschneidemaschinen"><h4>Laserschneidemaschinen</h4></Link>
                  <Link to="/Suppliers/Bodor/Laserschneiden?product=P-Serie" name="Bodor P-Serie"><h5>P-Serie</h5></Link>
                  <Link to="/Suppliers/Bodor/Laserschneiden?product=CT-Serie" name="Bodor CT-Serie"><h5>CT-Serie</h5></Link>
                  <Link to="/Suppliers/Bodor/Laserschneiden?product=i-Serie" name="Bodor i-Serie"><h5>i-Serie</h5></Link>
                  <Link to="/Suppliers/Bodor/Laserschneiden?product=T-Serie" name="Bodor T-Serie"><h5>T-Serie</h5></Link>
                  <Link to="/Suppliers/Bodor/Laserschneiden?product=M-Serie" name="Bodor M-Serie"><h5>M-Serie</h5></Link>
                  <Link to="/Suppliers/Bodor/Automatisierung" name="Bodor Automatisierung"><h4>Automatisierung</h4></Link>
                  <Link to="/Suppliers/Fanuc" name="Fanuc Overview Page"><h3>Fanuc</h3></Link>
                  </div>
              </div>
            </section>
            <hr/>
            <section>
            <div className="container">
              <center><h2>Mitglied im</h2></center>
              <div className="homePageMember" >
                <a name="link_to_vdwf" aria-label="link_to_vdwf" href="https://www.vdwf.de" rel="noopener noreferrer" target="_blank"><img className="imageOverviewLieferant" src={vdwf} alt="" width="100%" height="auto" /></a>
              </div>
            </div>
          </section>
          <hr/>
          <Modal show={this.state.show} onHide={this.handleClose} >
            <Modal.Header closeButton>
              <Modal.Title>{this.state.product}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Grid>
                <Row>
                  <Col xsHidden md={12}>
                    <img className="imageSupProdModal" src={this.state.image} alt={this.state.product}/>
                  </Col>
                </Row>
              </Grid>
              <h5>{this.state.sizeType}</h5>
              <p>{this.state.sizeData} &nbsp; {this.state.sizeMeas}</p>
              <br/>
              <h5>Eigenschaften</h5>
              <ul className='unordEnumBase'>{this.state.listItemsProperties}</ul>
              <br/>
              <h5>Download</h5>
              <a href={this.state.pdfLink}>{this.state.pdfAlias} </a>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Schließen</Button>
            </Modal.Footer>
          </Modal>
        </div>
    );
    
    
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/pages/homePage.js